module.exports = "/_next/static/images/img__offer-messages-1fd38ad2c9c059edfbe2f32ce979e64a.png";